<template>
  <div :id="componentId" class="sp4-module-1" :style="moduleStyle">
    <div class="sp4-carousel-wrap">
      <img
        v-if="displayCurrentImage"
        class="sp4-carousel-image"
        referrerpolicy="no-referrer"
        :src="displayCurrentImage"
      >
      <div v-else class="sp4-carousel-placeholder">请配置轮播图</div>

      <div class="sp4-carousel-indicators" style="padding: 10px; border-radius: 4px;">
        <span
          v-for="(item, index) in imageList"
          :key="index"
          class="sp4-indicator-item"
          :class="{ active: activeIndex === index }"
          @click="handleDotClick(index)"
        />
      </div>
    </div>

    <div class="sp4-text-wrapper">
      <div class="sp4-text-area" :style="{ backgroundImage: bgImageUrl ? `url(${bgImageUrl})` : 'none' }">
        <div class="sp4-content-inner">
          <div class="sp4-info-section">
            <div class="sp4-title">{{ title || '标题' }}</div>

            <div class="sp4-subtitle-wrapper">
              <div class="sp4-decorative-dot" style="left: calc(50% - 68px - 60px);" />
              <div class="sp4-subtitle">{{ subTitle || '副标题' }}</div>
              <div class="sp4-decorative-dot" style="right: calc(50% - 68px - 60px);" />
            </div>

            <div class="sp4-desc">{{ desc || '文字内容' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpFourModule1',
  props: {
    componentId: {
      type: String,
      default: 'sp_four_module_1'
    }
  },
  data() {
    return {
      activeIndex: 0,
      timer: null,
      title: '项目介绍',
      subTitle: 'CHINA BRAND',
      desc: '"中国品牌战略合作伙伴"由《中国品牌》杂志发起，旨在整合社会各方优势资源，为打造更多享誉世界的中国品牌而提供全面、系统的专业服务，为优秀的中国品牌赋能，让消费中国品牌成为一种国际风尚。',
      bgImageUrl: '',
      imageList: [
        { url: '' },
        { url: '' }
      ]
    }
  },
  computed: {
    displayCurrentImage() {
      const list = (this.imageList || [])
      if (list.length === 0) return ''
      const item = list[this.activeIndex]
      return item && item.url ? item.url : (item || '')
    },
    moduleStyle() {
      return {}
    }
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    startAutoPlay() {
      const count = (this.imageList || []).filter(item => item && item.url).length
      // eslint-disable-next-line no-console
      console.log('imageList count:', count, 'imageList:', this.imageList)
      if (count <= 1) return
      this.timer = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % count
      }, 3000)
    },
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    handleDotClick(index) {
      this.activeIndex = index
    }
  }
}
</script>

<style scoped>

</style>
